import * as tslib_1 from "tslib";
// Core components
import { OnInit } from "@angular/core";
// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';
// Custom components
var SingleFileViewerTypeComponent = /** @class */ (function (_super) {
    tslib_1.__extends(SingleFileViewerTypeComponent, _super);
    /**
     * Class constructor
     */
    function SingleFileViewerTypeComponent(configService, translateService, toastrService) {
        var _this = _super.call(this) || this;
        _this.configService = configService;
        _this.translateService = translateService;
        _this.toastrService = toastrService;
        return _this;
    }
    /**
     * Init component
     *
     * @since 1.0.0
     */
    SingleFileViewerTypeComponent.prototype.ngOnInit = function () {
        var key = this.field.key;
        if (this.model[key]) {
            this.file = this.model[key];
            var path = this.file.path.replace(/src[\\\/]assets/g, 'public');
            var url = "";
            // if (path.substring(0,22) === "https://app.archedi.it") {
            //   url = path;
            // } else {
            //   url = `${this.configService.apiHost}/${path}`;
            // }
            url = this.configService.apiHost + "/" + path;
            this.file = tslib_1.__assign({}, this.file, { url: url });
        }
    };
    /**
     * Handle dialog closing
     *
     * @since 1.0.0
     *
     */
    SingleFileViewerTypeComponent.prototype.onDownload = function (file) {
        FileSaver.saveAs(file.url, file.originalName);
    };
    return SingleFileViewerTypeComponent;
}(FieldType));
export { SingleFileViewerTypeComponent };
